import { useState } from 'react';
import { useAdvertisements } from '../../../features/advertisements/useAdvertisements';

export const useOnUpdatePostClicked = (formState = {}, imageUrlLarge, imageUrlSmall, videoUrlLarge, videoUrlSmall, id) => {

    const { updateAdvertisement } = useAdvertisements();
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);
    const [formError, setformError] = useState()
    const onUpdatePostClicked = async () => {
        setLoading(true);
        console.log(formState)
        try {
            const formData = {
                id: formState.id,
                name: formState.name,
                forward: formState.forward,
                servicepoint_ids: Array.isArray(formState.servicepoint_ids)
                    ? formState.servicepoint_ids.map((sp) => sp.id ?? sp)
                    : [formState.servicepoint_ids.id ?? formState.servicepoint_ids],
                file_type: formState.file_type,
                play_time: formState.play_time,
                file_path_small: imageUrlSmall ?? videoUrlSmall ?? formState.file_path_small,
                file_path_large: imageUrlLarge ?? videoUrlLarge ?? formState.file_path_large,
            };
            const response = await updateAdvertisement(id, formData);
            setResponse(response);
            setformError(response.errors)
        } catch (error) {
            const errorResponse = error?.data?.errors || { message: 'Bilinmeyen hata oluştu' };
            setResponse(errorResponse);
            return errorResponse;
        } finally {
            setLoading(false);
        }
    };

    return {
        response,
        formError,
        loading,
        onUpdatePostClicked,
    };
};
